import { jsxs, jsx } from "react/jsx-runtime";
import { listMissingVariables } from "../../../utils/index.js";
import { Box } from "@mui/material";
import { Text } from "@nxt-costco-com/forge-components";
import { COMPOSABLE_DATA_GOLD_HOURS_START_AT, COMPOSABLE_DATA_OPENING_TIME, COMPOSABLE_DATA_EXEC_HOURS_START_AT, COMPOSABLE_DATA_CLOSED_UNTIL, COMPOSABLE_DATA_OPENING_DAY, COMPOSABLE_DATA_CLOSED_FOR_EMERGENCY, COMPOSABLE_DATA_REASON, COMPOSABLE_DATA_CLOSED_FOR_HOLIDAY, COMPOSABLE_DATA_OPEN_UNTIL, COMPOSABLE_DATA_CLOSING_TIME, UNIQUE_ID, COMPOSABLE_DATA_OPEN_FOR_EXEC, COMPOSABLE_DATA_CLOSED } from "./constants.js";
import { getAllOpeningHours, convertTZ, convertDateTo12HourFormat } from "./utils.js";
import { commonSx, ClosedSx, OpenSx } from "./styles.js";
const OpeningHours = ({
  hours,
  holidays,
  timeZone,
  entry,
  variant = "t6",
  sx
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const missingProps = listMissingVariables({
    entry,
    hours,
    timeZone
  });
  if ((missingProps == null ? void 0 : missingProps.length) > 0) {
    console.error(`Missing props: ${missingProps}}`);
    return null;
  }
  const composableData = {};
  entry.composable_window.forEach(
    (curr) => composableData[curr.text_only.development_field_key] = curr.text_only.body
  );
  const openDateHoursObj = getAllOpeningHours(hours, timeZone, holidays);
  if (!(openDateHoursObj.openForAllDate || openDateHoursObj.openForExecutiveDate)) {
    return null;
  }
  const openDateForAllInMs = openDateHoursObj.openForAllDate ? new Date(openDateHoursObj.openForAllDate).getTime() : null;
  const openDateForExecutiveInMs = openDateHoursObj.openForExecutiveDate ? new Date(openDateHoursObj.openForExecutiveDate).getTime() : null;
  const date = /* @__PURE__ */ new Date();
  const todaysDate = convertTZ(date, timeZone);
  const currentTimeInMs = todaysDate.getTime();
  const closestOpeningTimeInMs = openDateForAllInMs && openDateForExecutiveInMs ? Math.min(openDateForAllInMs, openDateForExecutiveInMs) : openDateForAllInMs || openDateForExecutiveInMs || currentTimeInMs;
  let formattedOpenForAllTime = "";
  let formattedOpenForExecutiveTime = "";
  if (openDateHoursObj.openForAllDate) {
    formattedOpenForAllTime = convertDateTo12HourFormat(
      openDateHoursObj.openForAllDate
    );
  }
  if (openDateHoursObj.openForExecutiveDate) {
    formattedOpenForExecutiveTime = convertDateTo12HourFormat(
      openDateHoursObj.openForExecutiveDate
    );
  }
  let textSx = { ...commonSx };
  let displayText;
  let displayText1;
  switch (true) {
    case openDateHoursObj.isOpenForAll:
      displayText = formattedOpenForAllTime && ((_a = composableData[COMPOSABLE_DATA_OPEN_UNTIL]) == null ? void 0 : _a.replace(
        COMPOSABLE_DATA_CLOSING_TIME,
        formattedOpenForAllTime
      ));
      textSx = OpenSx;
      break;
    case openDateHoursObj.closedForHolidayToday.closedForHoliday:
      displayText = openDateHoursObj.closedForHolidayToday.reason.toUpperCase().includes("EMERGENCY") ? (_b = composableData[COMPOSABLE_DATA_CLOSED_FOR_EMERGENCY]) == null ? void 0 : _b.replace(
        COMPOSABLE_DATA_REASON,
        openDateHoursObj.closedForHolidayToday.reason
      ) : (_c = composableData[COMPOSABLE_DATA_CLOSED_FOR_HOLIDAY]) == null ? void 0 : _c.replace(
        COMPOSABLE_DATA_REASON,
        openDateHoursObj.closedForHolidayToday.reason
      );
      textSx = ClosedSx;
      break;
    case (!openDateHoursObj.isOpenForExecutive && !openDateHoursObj.isOpenForAll && closestOpeningTimeInMs - currentTimeInMs > 432e5):
      displayText = composableData[COMPOSABLE_DATA_CLOSED];
      textSx = ClosedSx;
      break;
    case ((!openDateHoursObj.openForExecutiveDate || openDateHoursObj.openForExecutiveDate && openDateForAllInMs === openDateForExecutiveInMs) && closestOpeningTimeInMs - currentTimeInMs < 432e5 && !openDateHoursObj.isOpenForAll):
      displayText = formattedOpenForAllTime && ((_e = (_d = composableData[COMPOSABLE_DATA_CLOSED_UNTIL]) == null ? void 0 : _d.replace(
        COMPOSABLE_DATA_OPENING_TIME,
        formattedOpenForAllTime
      )) == null ? void 0 : _e.replace(
        COMPOSABLE_DATA_OPENING_DAY,
        openDateHoursObj.openForAllDate ? openDateHoursObj.openForAllDate.toLocaleDateString(
          "en-US",
          { weekday: "long" }
        ) : ""
      ));
      textSx = ClosedSx;
      break;
    case (openDateHoursObj.openForExecutiveDate && openDateForAllInMs !== openDateForExecutiveInMs && !openDateHoursObj.isOpenForExecutive && !openDateHoursObj.isOpenForAll && closestOpeningTimeInMs - currentTimeInMs < 432e5):
      displayText = formattedOpenForExecutiveTime && ((_f = composableData[COMPOSABLE_DATA_EXEC_HOURS_START_AT]) == null ? void 0 : _f.replace(
        COMPOSABLE_DATA_OPENING_TIME,
        formattedOpenForExecutiveTime
      ));
      displayText1 = formattedOpenForAllTime && ((_g = composableData[COMPOSABLE_DATA_GOLD_HOURS_START_AT]) == null ? void 0 : _g.replace(
        COMPOSABLE_DATA_OPENING_TIME,
        formattedOpenForAllTime
      ));
      break;
    case (openDateHoursObj.openForExecutiveDate && openDateHoursObj.isOpenForExecutive && !openDateHoursObj.isOpenForAll):
      displayText = formattedOpenForExecutiveTime && `${composableData[COMPOSABLE_DATA_OPEN_FOR_EXEC]}`;
      displayText1 = formattedOpenForAllTime && ((_h = composableData[COMPOSABLE_DATA_GOLD_HOURS_START_AT]) == null ? void 0 : _h.replace(
        COMPOSABLE_DATA_OPENING_TIME,
        formattedOpenForAllTime
      ));
      break;
    default:
      return null;
  }
  return /* @__PURE__ */ jsxs(
    Box,
    {
      sx: {
        display: "flex",
        flex: 1,
        flexDirection: "column",
        flexWrap: "wrap"
      },
      children: [
        displayText && /* @__PURE__ */ jsx(
          Text,
          {
            sx: { ...textSx, ...sx },
            uniqueId: UNIQUE_ID,
            variant,
            children: displayText
          }
        ),
        displayText1 && /* @__PURE__ */ jsx(
          Text,
          {
            sx: { ...textSx, ...sx },
            uniqueId: `${UNIQUE_ID}_1`,
            variant,
            children: displayText1
          }
        )
      ]
    }
  );
};
export {
  OpeningHours
};
